import type { AuthProfile } from "../../lib/types";

export type SuperAdminPanelState =
  | { status: "hidden" }
  | { status: "organisations" }
  | { status: "jobs" }
  | { status: "feature-flags" }
  | { status: "organisation-detail"; organisationId: string }
  | { status: "demo-data"; organisationId: string };

export type OrganisationDetailPanelState = Extract<SuperAdminPanelState, { status: "organisation-detail" }>;

export function isOrganisationDetailPanelState(state: SuperAdminPanelState): state is OrganisationDetailPanelState {
  return state.status === "organisation-detail";
}

export function createInitialSuperAdminPanelState(): SuperAdminPanelState {
  return { status: "hidden" };
}

export function openSuperAdminPanel(_: SuperAdminPanelState): SuperAdminPanelState {
  return { status: "organisations" };
}

export function openSuperAdminJobs(_: SuperAdminPanelState): SuperAdminPanelState {
  return { status: "jobs" };
}

export function openSuperAdminFeatureFlags(_: SuperAdminPanelState): SuperAdminPanelState {
  return { status: "feature-flags" };
}

export function viewOrganisationDetail(_: SuperAdminPanelState, organisationId: string): SuperAdminPanelState {
  return { status: "organisation-detail", organisationId };
}

export function viewOrganisationDemoData(_: SuperAdminPanelState, organisationId: string): SuperAdminPanelState {
  return { status: "demo-data", organisationId };
}

export function returnToOrganisationsList(_: SuperAdminPanelState): SuperAdminPanelState {
  return { status: "organisations" };
}

export function closeSuperAdminPanel(_: SuperAdminPanelState): SuperAdminPanelState {
  return { status: "hidden" };
}

export function shouldRenderSuperAdminBookmark(profile: Pick<AuthProfile, "superAdmin"> | null | undefined): boolean {
  return Boolean(profile?.superAdmin);
}
